// extracted by mini-css-extract-plugin
export var downArrow = "_6o-0";
export var infoTooltipIcon = "_6o-3";
export var label = "_6o-1";
export var optionCard = "_6o-4";
export var upArrow = "_6o-2";